import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: 'rotate(90deg)',
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles('dark', {
    backgroundColor: 'rgba(255, 255, 255, .05)',
  }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions({accordionSet}) {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
        {accordionSet.map((item, index) => (
        <Accordion key={index} sx={{ backgroundColor: "transparent", border: "none" }} expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}>
            <AccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '1.2rem' }} />} // 自定义ArrowForwardIosSharpIcon 覆盖默认
                              sx={{ backgroundColor: "transparent", marginBottom: {sm: 4, xs: 0} }}
                              aria-controls={`panel${index}d-content`}
                              id={`pandel${index}d-header`}>
                <Typography component="h6"
                            variant="h6"
                            sx={{ color: 'rgb(45, 43, 42)',
                                  transition: 'all 0.1s ease',
                                  fontSize: expanded === `panel${index}` ? '1.5rem' : '1.25rem',
                                  '&:hover': {
                                    fontSize: '1.5rem',
                                  }, }}>
                  {item.summary}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{backgroundColor: "transparent", borderTop: '2px solid #EF7F95'}} >
                <Typography sx={{color: "#424242"}} >
                    {item.detail}
                </Typography>
            </AccordionDetails>
        </Accordion>
        ))}
    </div>
  );
}
